<av-content-container [fullHeight]="true">
  <div
    class="d-flex flex-column align-items-center justify-content-center gap-3 w-100 h-100 py-3"
    aria-live="polite"
    [attr.aria-busy]="wait.busy()"
  >
    @if (wait.visible()) {
      <av-spin size="lg" />
      <p class="m-0 text-muted">{{ 'app.catalog.demandReference.loading' | translate }}</p>
    }
  </div>
</av-content-container>
